import { Select } from "antd"
import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Button,
} from "reactstrap"

const ServiceModal = ({
  isOpen,
  toggle,
  serviceData,
  onChange,
  onSave,
  type = "",
}) => {
  const [errors, setErrors] = useState({})

  const validate = () => {
    const newErrors = {}

    if (!serviceData.name || serviceData.name.trim() === "") {
      newErrors.name = "Service Name is required"
    }
    if (!serviceData.description || serviceData.description.trim() === "") {
      newErrors.description = "Service Description is required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = e => {
    if (validate()) {
      onSave(e) // only call parent's save if valid
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {type === "view"
          ? "View Service"
          : serviceData?.id
          ? "Edit Service"
          : "Add Service"}
      </ModalHeader>
      <ModalBody>
        {/* Name */}
        <div className="mb-3">
          <Label>
            Service Name <span className="text-danger">*</span>
          </Label>
          <Input
            type="text"
            name="name"
            value={serviceData.name || ""}
            onChange={e => {
              onChange(e)
              setErrors(prev => ({ ...prev, name: "" })) // clear error on change
            }}
            disabled={type === "view"}
            placeholder="Enter Service Name"
          />
          {errors.name && <small className="text-danger">{errors.name}</small>}
        </div>

        {/* Description */}
        <div className="mb-0">
          <Label>
            Service Description <span className="text-danger">*</span>
          </Label>
          <Input
            type="textarea"
            style={{ resize: "none" }}
            name="description"
            value={serviceData.description || ""}
            onChange={e => {
              onChange(e)
              setErrors(prev => ({ ...prev, description: "" })) // clear error on change
            }}
            disabled={type === "view"}
            placeholder="Enter Service Description"
          />
          {errors.description && (
            <small className="text-danger">{errors.description}</small>
          )}
        </div>
      </ModalBody>

      {type === "" && (
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSubmit}>
            Save
          </Button>
          <Button className="btn-cancel" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      )}
    </Modal>
  )
}

export default ServiceModal
